import React from 'react'
import { useAuth } from 'context/authentication/useAuth'
import styled from 'styled-components'
import { MobileSearchBar } from 'components/MobileSearch/MobileSearchBar'
import { MobileColors } from '../../../styles/mobileTokens'

const WelcomeText = styled.div`
  font-size: 30px;
  font-weight: 400;
`

const CompanyName = styled.span`
  font-weight: 600;
  color: ${MobileColors.primary};
`

const Container = styled.div`
  padding: 60px 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export default function Home() {
  const { user } = useAuth()

  return (
    <Container>
      <WelcomeText>
        <div>Welcome,</div>
        <CompanyName>{user?.company?.name}</CompanyName>
      </WelcomeText>
      <MobileSearchBar defaultSearchType="fb_company" showDropdown={true} />
    </Container>
  )
}
